module.exports = __webpack_public_path__ + "static/media/not-allowed.9b9608f6.svg";